import * as Palette from '@mlc/mlc-palette';
import { css } from 'styled-components';

export default () => css`
	display: inline-block;

	.autosuggest__container {
		position: relative;
	}

	.autosuggest__input {
		background: ${Palette.mlcWhite};
		border: none;
		box-shadow: none;
	}

	.autosuggest__suggestions-container {
		display: none;
	}

	.autosuggest__suggestions-container--open {
		display: block;
		position: absolute;
		z-index: 2;
	}

	.autosuggest__suggestions-list {
		list-style-type: none;
		margin: 0;
		padding: 0;
	}

	.autosuggest__suggestion {
		cursor: pointer;
	}
`;
